import React, { useEffect, useState } from 'react'
import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  useMediaQuery,
  Typography,
} from '@material-ui/core'
import { useVestigioService } from 'hooks/useVestigioService'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import useStyles from './styles'
import { popularAcoes } from './timelineHelper'

const sintetizarUsuario = (usuario) => {
  if (!usuario || usuario === ' - ') return '-'
  const nomeCompleto = usuario.split(' - CPF:')[0].trim()
  if (nomeCompleto.toLowerCase() === 'outro' || nomeCompleto.toLowerCase() === 'não informado') {
    return nomeCompleto.toUpperCase()
  }
  const partes = nomeCompleto.split(' ')
  if (partes.length <= 2) {
    return nomeCompleto.toUpperCase()
  }
  return `${partes[0]} ${partes[partes.length - 1]}`.toUpperCase()
}

export const FAV = (props) => {
  const classes = useStyles()
  const { idVestigio } = props
  moment.locale('pt-br', localization)

  const [vestigio, setVestigio] = useState(null)
  const [acoes, setAcoes] = useState([])
  const [loading, setLoading] = useState(false)
  const vestigioService = useVestigioService()

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const carregandoEfetivo = props.carregando !== undefined ? props.carregando : loading

  useEffect(() => {
    const fetchVestigioTimeLine = async () => {
      const setCarregandoEfetivo = props.setCarregando || setLoading
      setCarregandoEfetivo(true)
      try {
        const vest = await vestigioService.listarVestigioTimelineAsync(idVestigio)
        setVestigio(vest)
      } catch (error) {
        console.error('Erro ao buscar timeline do vestígio:', error)
      } finally {
        setCarregandoEfetivo(false)
      }
    }

    if (idVestigio) {
      fetchVestigioTimeLine()
    }
  }, [idVestigio, props.setCarregando])

  useEffect(() => {
    if (vestigio && vestigio.id) {
      setAcoes(popularAcoes(vestigio))
    }
  }, [vestigio])

  return (
    <div>
      {carregandoEfetivo ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : isMobile ? (
        <div className={classes.mobileContainer}>
          {acoes?.length ? (
            acoes.map((acao) => (
              <div key={acao.id} className={classes.mobileCard}>
                <div className={classes.mobileHeader}>
                  <Typography className={classes.mobileActionTitle}>
                    {acao.operacao?.toUpperCase() || ''}
                  </Typography>
                </div>
                <div className={classes.mobileDetailRow}>
                  <Typography className={classes.mobileDetailItem} variant="body2">
                    Usuário: <span>{sintetizarUsuario(acao.usuario)}</span>
                  </Typography>
                  <Typography className={classes.mobileDetailItem} variant="body2">
                    Setor: <span>{acao.setor?.toUpperCase() || '-'}</span>
                  </Typography>
                  <Typography className={classes.mobileDetailItem} variant="body2">
                    Lacre: <span>{acao.lacre || '-'}</span>
                  </Typography>
                  {acao.numeracao && acao.numeracao !== ' - ' && (
                    <Typography className={classes.mobileDetailItem} variant="body2">
                      Numeração: <span>{acao.numeracao}</span>
                    </Typography>
                  )}
                  <Typography className={classes.mobileDetailItem} variant="body2">
                    Data/Hora: <span>{moment(acao.data).format('DD/MM/YYYY HH:mm')}</span>
                  </Typography>
                </div>
              </div>
            ))
          ) : (
            <div className={classes.mobileCard} style={{ textAlign: 'center' }}>
              <Typography className={classes.emptyState}>
                Não há registro de operações para este vestígio
              </Typography>
            </div>
          )}
        </div>
      ) : (
        <TableContainer className={classes.tableContainer}>
          <Table className={classes.table} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow className={classes.tableHeader}>
                <TableCell className={classes.tableHeaderCell}>Operação</TableCell>
                <TableCell className={classes.tableHeaderCell}>Usuário</TableCell>
                <TableCell className={classes.tableHeaderCell}>Setor</TableCell>
                <TableCell className={classes.tableHeaderCell}>Lacre</TableCell>
                <TableCell className={classes.tableHeaderCell}>Data</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {acoes?.length ? (
                acoes.map((acao) => (
                  <TableRow key={acao.id} className={classes.tableRow}>
                    <TableCell className={classes.tableCell} component="th" scope="row" width="25%">
                      {acao.operacao?.toUpperCase() || ''}
                    </TableCell>
                    <TableCell className={classes.tableCell}>{acao.usuario?.toUpperCase() || '-'}</TableCell>
                    <TableCell className={classes.tableCell}>{acao.setor?.toUpperCase() || '-'}</TableCell>
                    <TableCell className={classes.tableCell}>{acao.lacre || '-'}</TableCell>
                    <TableCell className={classes.tableCell}>
                      {moment(acao.data).isValid() ? moment(acao.data).format('DD/MM/YYYY HH:mm') : '-'}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow className={classes.tableRow}>
                  <TableCell colSpan={5} className={classes.emptyState}>
                    Não há registro de operações para este vestígio
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  )
}
